import { gql } from "lib/apolloClient";
import { aiFragment, attachmentFragment } from "modules/CommonFragments";

export const getUnitPlanDetailsQuery = gql`
  query getUnitPlanDetails($id: ID!) {
    node(id: $id, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        resolvedGrades {
          id
          name
        }
        subjects {
          id
          resolvedMinimalTree {
            id
            ... on ResolvedFieldSubjectSet {
              id
              subjects {
                id
                name
              }
            }
          }
        }
        aiConversation {
          edges {
            node {
              id
              entitySubType
            }
          }
        }
      }
    }
  }
`;

export const getAIPromptsQuery = gql`
  query getAIPrompts($filters: PromptFilters!) {
    ai {
      prompts(filters: $filters) {
        id
        displayText
        displayTextLocale
        entityType
        promptType
        action
        fieldType
        displaySequence
        groupType
        isTimeDependent
        startDate
        endDate
        promptFields {
          field
          type
          config
          isRequired
        }
        children
        metadata
        templateAssessmentIds
      }
    }
  }
`;

export const getAIConversationsQuery = gql`
  query getAiConversation($id: ID!) {
    node(id: $id, type: AI_CONVERSATION) {
      ... on AiConversation {
        id
        entityType
        metadata
        messages {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...aiMessageItem
            }
          }
        }
        attachments {
          ...attachmentItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
  ${attachmentFragment.attachment}
`;

export const getFocusExplorationWithGlobalContextQuery = gql`
  query getFocusExplorationWithGlobalContext($id: ID!) {
    node(id: $id, type: IB_MYP_CURRICULUM_PROGRAM) {
      id
      ... on IbMypCurriculumProgram {
        id
        plannerElementSets(elementTypes: [MYP_EXPLORATION]) {
          id
          label
          type
          nodes {
            id
            label
            associatedParents {
              id
              ... on PlannerElementNode {
                id
                label
                type
                metadata
              }
            }
          }
        }
      }
    }
  }
`;
